const trackedImpressions = {};

export function trackImpressionForChallenge(challenge) {
    trackedImpressions[challenge.waterfallId] = true;
}


export function hadImpressionOnChallenge(challenge) {
    return Boolean(trackedImpressions[challenge.waterfallId]);
}


export function hadImpression() {
    return Object.keys(trackedImpressions).length;
}


// WEBPACK FOOTER //
// ./src/lib/impressionTracking.js